import Button from '@components/shared/Button'
import { useEventListener } from '@hooks/useEventListener'
import CloseIcon from '@icons/CloseIcon'
import { AddressWrapper } from '@layouts/WozCheckLayout/styles'
import { scrollLock } from '@utils/scrollLock'
import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import {
  BottomRow,
  ButtonWrapper,
  ContentWrapper,
  InfoWrapper,
  ModalCard,
  ModalContainer,
  ModalWrapper,
  TopRow,
} from './styles'
import { ModalProps } from './types'

const Modal = ({
  noMarginOnP,
  info,
  hasJuistFooter,
  contentNodes,
  title,
  size,
  content,
  address,
  buttons,
  open,
  onClose,
  children,
  disableScroll,
}: ModalProps) => {
  const [modalRoot, setModalRoot] = useState<HTMLDivElement | null>(null)

  const onEscKeyDown = (event: Event | KeyboardEvent) => {
    if (event instanceof KeyboardEvent && event.key.toLowerCase() === 'escape') {
      onClose && onClose()
    }
  }

  useEffect(() => {
    if (open && disableScroll) {
      scrollLock.enable()
    } else {
      scrollLock.disable()
    }

    return () => {
      scrollLock.disable()
    }
  }, [open])

  useEventListener('keydown', onEscKeyDown)

  useEffect(() => {
    setModalRoot(document.querySelector<HTMLDivElement>('#modal-root'))
  }, [])

  if (!modalRoot || !open) {
    return null
  }

  return ReactDOM.createPortal(
    <ModalContainer onClick={() => onClose && onClose() }>
      <ModalWrapper>
        <ModalCard
          small={size === 'small'}
          noMarginOnP={!!noMarginOnP}
          onClick={e => {
            e.stopPropagation()
          }}
        >
          <TopRow>
            <h2>{title}</h2>
            {onClose && (
              <div onClick={() => onClose()}>
                <CloseIcon />
              </div>
            )}
          </TopRow>
          <ContentWrapper>
            {content && <div dangerouslySetInnerHTML={{ __html: content }} />}
            {info && <InfoWrapper dangerouslySetInnerHTML={{ __html: info }} />}
            {contentNodes}
            {address && <AddressWrapper>{address}</AddressWrapper>}
            {buttons && (
              <ButtonWrapper>
                {buttons.map((button, index) => {
                  const clickProps = button.link
                    ? {
                        href: button.link,
                      }
                    : button.onClick
                    ? {
                        onClick: button.onClick,
                      }
                    : {}
                  return (
                    <Button {...clickProps} key={index} linkType={button.link_type} variant={button.variant}>
                      {button.label}
                    </Button>
                  )
                })}
              </ButtonWrapper>
            )}
            {children}
          </ContentWrapper>
          {hasJuistFooter && (
            <BottomRow>
              <span>Uw bezwaar wordt afgehandeld door:</span>
              <img width={200} height={146} src="../../../images/previcus_logo.png" alt={'Previcus'} />
            </BottomRow>
          )}
        </ModalCard>
      </ModalWrapper>
    </ModalContainer>,
    modalRoot
  )
}

export default Modal
